import { Injectable } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Dienststelle } from '../module/dienststelle';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DbService {
  constructor(
    private afs: AngularFirestore,
    private http: HttpClient,
  ) {}

  getDienststelleData(dsCode: string): Observable<Dienststelle> {
    if (dsCode === '') {
      dsCode = 'Kein Dienststellencode';
    }

    if (environment.useApi) {
      return this.getDienststelleFromApi(dsCode);
    }

    return this.afs
      .collection(environment.collectionName)
      .doc<Dienststelle>(dsCode)
      .valueChanges();
  }

  /**
   * Dienststellen-Parameter aus dem RIDE-Portal statt aus Firestore.
   *
   * Der Endpoint liefert dieselben 40 Felder wie ein Firestore-Dokument und
   * berechnet sie direkt aus der Portal-Datenbank - neue Dienststellen muessen
   * dort also nicht mehr von Hand angelegt werden.
   *
   * Fehler werden bewusst zu `undefined` gemappt, NICHT weitergereicht: der
   * Aufrufer in rechner.page.ts haengt per switchMap an data$ und hat keinen
   * error-Handler. Ein durchgereichter Fehler wuerde diesen Stream dauerhaft
   * beenden - die Eingabe weiterer Dienststellencodes bliebe bis zum Reload
   * wirkungslos. `undefined` entspricht dem Firestore-Verhalten bei einem
   * unbekannten Dokument und wird dort bereits mit `if (res)` abgefangen.
   *
   * Statuscodes: 404 unbekannter Code, 409 im Rechner nicht abbildbar
   * (mehrere Zuschuss-Modelle gleichzeitig / Code mehrfach vergeben).
   */
  private getDienststelleFromApi(dsCode: string): Observable<Dienststelle> {
    const url =
      environment.apiBaseUrl +
      '/calculator/service?code=' +
      encodeURIComponent(dsCode.trim());

    return this.http.get<Dienststelle>(url).pipe(
      catchError((err) => {
        if (err?.status !== 404) {
          console.error('Dienststelle konnte nicht geladen werden', err);
        }
        return of(undefined as unknown as Dienststelle);
      }),
    );
  }

  searchDocumentsByName(name: string): Observable<Document[]> {
    return this.afs
      .collection<Document>(environment.collectionName, (ref) =>
        ref.where('leasingDuration', '==', '30;24'),
      )
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => {
            const data = a.payload.doc.data() as Document;
            const id = a.payload.doc.id;
            return { id, ...data };
          }),
        ),
      );
  }

  // a function to get all documents and return what is needed
  // cahnge map to customize what u need to return
  getDsCodesWithDocumentIdContaining() {
    /*  this.afs.collection<Document>(environment.collectionName)
      .snapshotChanges().pipe(
      map(actions => actions
        // tslint:disable-next-line:triple-equals
        .filter(a => a.payload.doc.data()['ustAG'] === 2 && a.payload.doc.data()['ustAb'] && a.payload.doc.data()['ustAb'] != ''  )
        .map(a => {
          return {
            id: a.payload.doc.id,
            ustAb:  a.payload.doc.data()['ustAb'],
            ustAg: a.payload.doc.data()['ustAG']
          };
        })
      )
    ).subscribe({
      next: (doc: any) => {
        console.log(doc);

      }
    });*/
  }

  add() {
    return;
    // example how to add a new data to FirebaseDB
       this.afs.collection('/' + environment.collectionName )
      .doc('Ö-Emd-0726'.trim()).set(  // update
      {
        name: 'Stadt Emden',  // update
        VBL: 0.0, // (durch 100 teilen)
        disabledVBL: false, // update if exists
        aganteil: 0,  // pauschaler Zuschuss
        aganteilBeamte: 20.0,  // Beamte pauschaler Zuschuss
        bundesland: 'ni', // Bundesland von den Stammdaten (search for 'public bundesl')
        disabledBundesland: false,
        leasingfaktor: 0.033, // (durch 100 teilen)
        uebernahmeprozent: 0.18,  // update (durch 100 teilen)
        fairbetragBeamte: 0,  // (search for 'switch (fairbetrag)' to get the value)
        fairbetrag: 0,  // (search for 'switch (fairbetrag)' to get the value)
        disabledFairbetrag: true,
        inspektion: 1,  // 1 ist Basis und 2 ist Flex
        sonderInspektion: 10.0,  // Paketpreis / Monat
        disabledInspektion: false,  // Inspektion optional oder obligatorisch (obligatorisch means TRUE)
        ustAG: 0, // (0 or 1 means true or false) Vorsteuerabzugs-berechtigung
        hasSaving: true,  // most of the time is true (to show the right side section that has Kirsche ect)
        ustAGBeamte: 0, // (0 or 1 means true or false) Beamte Vorsteuerabzugs-berechtigung
        disabledUstAg: true,
        ustAb: '',  // date in form '02-30-2026' if exists Vorsteuerabzugs-berechtigung ab
        disabledUstAb: false, // mit absprache
        ustAbBeamte: '',  // date in form '02-30-2026' if exists Vorsteuerabzugs-berechtigung ab for Beamte
        oneProzent: 0,  // (0 or 1 means true or false) Ausgangsumsatz zu lasten Beamter
        oneProzentNetto: 0, // dont update
        oneProzentBeamte: 0,  // (0 or 1 means true or false) Ausgangsumsatz zu lasten Beamter for Beamte
        disabledOneProzent: true,  // mit absprache
        verGeber: 'HEPSTER', // Versicherer (BARMENIA or HEPSTER)
        versicherungNetto: 1, // 0 or 1 means true or false) always 1
        versicherungType: 'premium',  // Versicherungspaket (mal Fragen!)
        maxPreis: 7000, // Leasinghöchstgrenze
        minPreis: 499,  // Leasinguntergrenze
        leasingDuration: '36',  // ELV-Laufzeiten
        leasingRateBezuschussen: false, // Leasingrate Bezuschussen
        disabledRadFahrSchutz: true,  // mit absprache
        abwKonditionenBeamte: true,  // Beamte mit abweichenden Konditionen
        restwert: 0.1,  // (durch 100 teilen)
        hasHaftpflicht: false,  // mal fragen
        disabledBArt: false,  // always false
        customerType: 0,  // 0 = Beschäftigte, 1 = Freiberuflich, 2 = Business
      },
      { merge: true });

  }
}
